import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var RollLight = /*#__PURE__*/function () {
  function RollLight() {
    _classCallCheck(this, RollLight);
    this.enable = false;
    this.value = 0;
  }
  _createClass(RollLight, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.value !== undefined) {
        this.value = setRangeValue(data.value);
      }
    }
  }]);
  return RollLight;
}();